var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { blue05, blue20 } from '../../../colors/blue';
import { gray20, gray40opacity05, gray40opacity10, gray40opacity20, gray95opacity40, } from '../../../colors/gray';
import { rem } from '../../../utils/rem';
import { listStylesDark } from '../components/MuiListItem';
import { checkbox } from './checkbox';
import { inputText } from './inputText';
export var grid = {
    '.ag-theme-alpine': __assign(__assign({ '--ag-foreground-color': gray20, '--ag-row-border-bottom-color': gray40opacity10, '--ag-row-hover-color': listStylesDark.hover.backgroundColor, '--ag-selected-row-background-color': listStylesDark.selected.backgroundColor, '--yds-ag-cell-edit-border-color': blue05, '--ag-modal-overlay-background-color': gray95opacity40, '& .ag-header-row': {
            borderBottom: "".concat(rem(1), " solid ").concat(gray40opacity20),
        }, '& .ag-header-cell-sortable': {
            '&:hover': {
                color: blue20,
            },
        }, '& .ag-row': {
            fontSize: '0.875rem',
        }, '& .ag-row-focus': {
            '--ag-row-border-color': listStylesDark.focused.outlineColor,
            '--ag-row-border-bottom-color': listStylesDark.focused.outlineColor,
            outline: "".concat(rem(1), " solid var(--ag-row-border-color)"),
            outlineOffset: rem(-1),
        }, '& .ag-row-hover': {
            // In v28+ bg color applied to before elements...
            '&.ag-row-selected::before': {
                backgroundColor: listStylesDark.selectedHover.backgroundColor,
                backgroundImage: 'none',
            },
        }, 
        // variants
        '&.yds-grid-striped': {
            '--ag-odd-row-background-color': gray40opacity05,
        }, '&.yds-grid-cell-selection': {
            '--ag-range-selection-border-color': blue05,
            '& .ag-cell:hover:not(.ag-cell-focus)': {
                backgroundColor: listStylesDark.hover.backgroundColor,
            },
        } }, checkbox), inputText),
};
